module.exports = __webpack_public_path__ + "img/02-as-ktirio.399a0cbd.jpg";